<template>
	<section class="container" :class="{'not_work': isHoliday(schedule)}">
		<div
			v-if="!isHoliday(schedule)"
			class="record not_work"
			:style="workingDayStartLimit(schedule)"
		></div>
		<div
			v-if="!isHoliday(schedule)"
			class="record"
			:style="eventPosition(visit)"
			v-for="visit of eventFiltered">
			&nbsp;
		</div>
		<div
			v-if="!isHoliday(schedule)"
			class="record not_work"
			:style="workingDayEndLimit(schedule)"
		></div>
	</section>
</template>

<script>
	import moment from 'moment';
	import { eventColors, UTC as Time } from '@/common';

	export default {
		name: 'HorizontalEvent',
		props: ['dayAgenda', 'schedule'],
		computed: {
			percentPerHour() {
				return 100 / (this.workTime.end - this.workTime.start);
			},
			eventFiltered() {
				return this.dayAgenda.filter(item => item.status != 'canceled')
			}
		},
		data: () => ({
			workTime: {
				start: 7,
				end: 22,
			},
			specialSchedule: {
				special: [],
				vacation: [],
			},
		}),
		mounted() {
			console.log('dayAgenda - below see it')
			console.log(this.eventFiltered)
		},
		methods: {
			eventPosition(event) {
				return {
					'background-color': eventColors[event.status],
					'left': this.calcBegin(event),
					'width': this.calcWidth(event),
				};
			},

			workingDayStartLimit(schedule) {
				if (!schedule || !schedule.period.length) {
					return { 'width': 0 };
				}

				const begin = moment(this.workTime.start, 'H').format('X');
				const localEndTime = Time.toLocal(schedule.period[0].begin, 'HH:mm');
				const end = moment(localEndTime, 'HH:mm').format('X');

				return {
					'left': 0,
					'width': this.calcWidth({ begin, end }),
				}
			},

			workingDayEndLimit(schedule) {
				if (!schedule || !schedule.period.length) {
					return { 'width': 0 };
				}

				const localBeginTime = Time.toLocal(schedule.period[0].end, 'HH:mm');
				const begin = moment(localBeginTime, 'HH:mm').format('X');
				const end = moment(this.workTime.end, 'H').format('X');
				return {
					'left': this.calcBegin({ begin }),
					'width': this.calcWidth({ begin, end }),
				}
			},

			calcBegin({ begin }) {
				const hours = +moment(begin, 'X')
					.subtract(this.workTime.start, 'hours')
					.format('HH');

				// 0.016666666666667 - factor for transformation minutes to decimal numbers
				const minutes = +moment(begin, 'X').format('mm') * 0.016666666666667;
				return `${(this.percentPerHour * hours) + (this.percentPerHour * minutes)}%`;
			},

			calcWidth({ begin, end }) {
				let difference = (+end - +begin) / 3600;
				difference = difference > 0 ? difference : 0;
				return `${this.percentPerHour * difference}%`;
			},

			isHoliday(schedule) {
				// todo add checking of vacations and special days
				return !schedule || !schedule.period.length;
			},

			// fixme it's logic of vacations and special days copied from LargeSchedule component
			setSpecial(array = []) {
				this.specialSchedule = {
					vacation: [],
					special: [],
				};

				array.forEach((record) => {
					if (moment(record.begin, 'X').format('DD') !== moment(record.end, 'X').format('DD')) {
						this.specialSchedule.vacation.push(record);
					} else {
						this.specialSchedule.special.push(record);
					}
				});
			},

			checkWorkTime(time, day) {
				return !this.checkVacations(this.specialSchedule.vacation, day) && this.checkSchedule(time, day);
			},

			checkVacations(vacations, day) {
				let validDay = moment(day, 'DD-MM-YYYY');

				for (let i = 0; i <= vacations.length - 1; i++) {
					let begin = moment(vacations[i].begin, 'X');
					let end = moment(vacations[i].end, 'X');

					if (validDay.isSameOrAfter(begin, 'day') && validDay.isSameOrBefore(end, 'day')) {
						return true;
					}
				}

				return false;
			},

			checkSchedule(time, day) {
				for (let i = 0; i <= this.specialSchedule.special.length - 1; i++) {
					let record = this.specialSchedule.special[i];

					if (moment(record.begin, 'X').format('DD-MM-YYYY') === day) {
						return this.checkSpecialDays(record, time, day);
					}
				}

				return this.checkUsualSchedule(this.schedule, time, day);
			},

			checkSpecialDays(record, time, day) {
				let validTime = moment(time + ' ' + day, 'HH:mm DD-MM-YYYY');
				let begin = moment(record.begin, 'X');
				let end = moment(record.end, 'X');

				return !this.contains(record.type, 'not_work') && (validTime.isSameOrAfter(begin, 'minute') && validTime.isBefore(end, 'minute'));
			},

			contains(array, value) {
				return !!array.find(item => item === value);
			},

			checkUsualSchedule(schedule, time, day) {
				if (schedule.length === 0) {
					console.warn('Schedule argument is invalid');
					return false;
				}

				let validTime = moment(time, 'HH:mm');
				let dayNumber = moment(day, 'DD-MM-YYYY').format('e');
				let scheduleDay = this.dayAgenda;
				let result = false;

				if (!scheduleDay) {
					return false;
				}

				if (!!scheduleDay.period && scheduleDay.period.length === 0) {
					return false;
				}

				for (let i = 0; i <= scheduleDay.period.length - 1; i++) {
					let record = scheduleDay.period[i];
					let begin = moment(Time.toLocal(record.begin), 'HH:mm');
					let end = moment(Time.toLocal(record.end), 'HH:mm');

					return (validTime.isSameOrAfter(begin, 'minute') && validTime.isBefore(end, 'minute'));
				}

				return false;
			},
		}
	};
</script>

<style scoped>
	.container {
		position: relative;
		width: 100%;
		height: 99%;
	}

	.not_work {
		background-color: #cdcdcdb5;
		pointer-events: none;
	}

	.record {
		position: absolute;
		color: #000;
		height: 98%;
	}
</style>



// WEBPACK FOOTER //
// HorizontalEvent.vue?a3484cbe